export enum ReviewRequestType {
  SIGNIFICANT_ENHANCEMENT = "SIGNIFICANT_ENHANCEMENT",
  APPLICATION_INTEGRATION = "APPLICATION_INTEGRATION",
  DATA_ACCESS = "DATA_ACCESS",
  PRODUCTION_READINESS = "PRODUCTION_READINESS",
}

export interface ReviewRequestFormSubmission {
  reviewType: ReviewRequestType;
  values: Record<string, unknown>;
}
